import { cn } from '@/utils/cn'
import navConfig from '@/config/navigation'
import { useAuthStore } from '@/stores/auth.store'

import NavigationExpandable from './NavigationExpandable'
import NavigationItem from './NavigationItem'

const Navigation = () => {
  const permissions = useAuthStore((s) => s.permissions)
  const permissionsError = useAuthStore((s) => s.permissionsError)
  const role = permissions?.role
  const isSuperAdmin = role === 'SUPER_ADMIN'
  const isAdmin = role === 'ADMIN'

  return (
    <nav className='mt-0 flex-1 md:mt-4' aria-label='Sidebar'>
      {navConfig.map(({ id, header, children }, index) => (
        <div key={id} className={cn({ 'mt-8': index > 0 })}>
          {header && (
            <h3
              id={`${id}-headline`}
              className='text-elements-dark-contrastText/60 px-3 text-xs font-semibold tracking-wider uppercase'
            >
              {header}
            </h3>
          )}

          <div
            className={cn('space-y-1', { 'mt-2': header })}
            role='group'
            aria-labelledby={header ? `${id}-headline` : undefined}
          >
            {children.map((item) => {
              const visibleChildIds =
                item.id === 'control-center'
                  ? item.children
                      ?.filter((c) => {
                        if (c.id === 'configuration') return isSuperAdmin
                        if (c.id === 'feature-flags') return isSuperAdmin
                        if (c.id === 'alerts') return isSuperAdmin || isAdmin
                        return false
                      })
                      .map((c) => c.id)
                  : undefined

              // Hide the section when:
              //   - permissions loaded and user has no qualifying role, OR
              //   - the permissions fetch failed (fail-closed: unknown ≠ allowed)
              // Keep visible while permissions === null with no error (still loading)
              // so a legitimate admin doesn't see the section flicker in.
              if (
                item.id === 'control-center' &&
                (permissionsError ||
                  (permissions !== null && visibleChildIds?.length === 0))
              ) {
                return null
              }

              if (item.children && item.children.length > 0) {
                return (
                  <NavigationExpandable
                    key={item.id}
                    {...item}
                    visibleChildIds={visibleChildIds}
                  />
                )
              }

              return <NavigationItem key={item.id} {...item} />
            })}
          </div>
        </div>
      ))}
    </nav>
  )
}

export default Navigation
